module.exports = __webpack_public_path__ + "static/media/kumar-dai.5041ac07.jpg";